import axios from "axios";
import moment from "moment";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getUsuarios() {
    return await instance.get("/users/getall").then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async getContatos () {
    return await instance.get('/contatos/get').then(async (response) => {
      return await response.data;
    }, (error) => {
        console.log(error);
    });
  },

  async getUsuario(id) {
    return await instance.get("/users/id/" + id).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },

  async saveUsuario(name, email, senha, acesso) {
    return await instance
      .post("/users/register", {
        name: name,
        email: email,
        password: senha,
        acesso: acesso
      })
      .then(
        async response => {
          return await response.data;
        },
        error => {
          console.log(error);
        }
      );
  },
  async alterarUsuario(id, acesso, name) {
    return await instance.put("/users/alterar/" + id, { acesso: acesso, name: name }).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },

  async deleteUser(id) {
    return await instance.delete("/users/remove/" + id).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  
  async deleteContato(id) {
    return await instance.delete("/contatos/remove/" + id).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/usuario.js